import header from '../views/common/header';
import gnb from '../views/common/gnb';

export default [
  {
    path: '/views/analysis/owlview',
    meta: { stackType: 'ALL' },
    components: {
      default: () => import('../views/analysis/OwlViewNeo.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/analysis/owlview/:systemId',
    meta: { stackType: 'ALL' },
    components: {
      default: () => import('../views/analysis/OwlViewNeo.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/analysis/owlview-viewer',
    meta: { fixedMinSize: false },
    components: {
      default: () => import('../views/analysis/OwlViewNeo.vue'),
    },
  },
  {
    path: '/views/analysis/owlview-viewer/:systemId',
    meta: { fixedMinSize: false },
    components: {
      default: () => import('../views/analysis/OwlViewNeo.vue'),
    },
  },
  {
    path: '/views/analysis/ssr-viewer',
    meta: { fixedMinSize: false },
    components: {
      default: () => import('../views/analysis/ssr/SSRViewer.vue'),
    },
  },
  {
    path: '/views/analysis/dsr-viewer',
    meta: { fixedMinSize: false },
    components: {
      default: () => import('../views/analysis/dsr/DSRViewer.vue'),
    },
  },
  {
    path: '/views/analysis/sql-viewer',
    meta: { fixedMinSize: false },
    components: {
      default: () => import('../views/analysis/sql/SQLViewer.vue'),
    },
  },
  {
    path: '/views/analysis/sql-viewer-hana',
    meta: { fixedMinSize: false },
    components: {
      default: () => import('../views/analysis/sql/SQLViewer4Hana.vue'),
    },
  },
  {
    path: '/views/analysis/user-history',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/analysis/history/user/UserHistoryNeo.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/analysis/user-history/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/analysis/history/user/UserHistoryNeo.vue'),
      header,
      gnb,
    },
  },
  // BEGIN::Added.by.KWShin.2026.07.09.
  {
    path: '/views/analysis/user-neo-history',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/analysis/history/user-neo/UserHistory.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/analysis/user-neo-history/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/analysis/history/user-neo/UserHistory.vue'),
      header,
      gnb,
    },
  },
  // FINISH::Added.by.KWShin.2026.07.09.
  // BEGIN::Added.by.KWShin.2026.09.03.
  {
    path: '/views/analysis/user-ch-history',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/analysis/history/user-neo-clickhouse/UserHistory.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/analysis/user-ch-history/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/analysis/history/user-neo-clickhouse/UserHistory.vue'),
      header,
      gnb,
    },
  },
  // FINISH::Added.by.KWShin.2026.09.03.
  {
    path: '/views/analysis/program-history',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/analysis/history/program/ProgramHistoryNeo.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/analysis/program-history/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/analysis/history/program/ProgramHistoryNeo.vue'),
      header,
      gnb,
    },
  },
  // BEGIN::Added.by.KWShin.2025.08.25.
  {
    path: '/views/analysis/expensive-sql',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/analysis/expensive/ExpensiveSql.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/analysis/expensive-sql/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/analysis/expensive/ExpensiveSql.vue'),
      header,
      gnb,
    },
  },
  // FINISH::Added.by.KWShin.2025.08.25.
  {
    path: '/views/analysis/alert',
    meta: { hiddenGroupSelector: true },
    components: {
      default: () => import('../views/analysis/alert/Alert.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/analysis/context',
    components: {
      default: () => import('../views/analysis/context/ContextAnalyzer.vue'),
    },
  },
  // BEGIN::Added.by.KWShin.2024.07.19.
  {
    path: '/views/analysis/context-analyzer',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/analysis/context/ContextAnalyzerNeo.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/analysis/context-analyzer/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/analysis/context/ContextAnalyzerNeo.vue'),
      header,
      gnb,
    },
  },
  // FINISH::Added.by.KWShin.2024.07.19.
];
